import { Box, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';

const BBB = () => (
  <Flex>
    <Box
      flex={1}
      display="flex"
      flexDirection={['column', 'column', 'row']}
      justifyContent="center"
      alignItems="center"
      gap={[0, 0, 12]}
      my={['0px', '-20px']}
    >
      <Text mr={[0, 4, 3, 0]} textStyle="p_lg" fontWeight={500}>
        Rated A+ by the BBB
      </Text>
      <Link
        href="https://www.bbb.org/us/ca/san-francisco/profile/medicare/fair-square-medicare-1116-927222"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Box minW={['200px', '240px', '300px']} height="100px" position="relative" objectFit="cover" mt={[4, 4, 0]}>
          <Image src="/FSM-BBB-Logo.svg" alt="Better Business Bureau logo." fill />
        </Box>
      </Link>
    </Box>
  </Flex>
);

export default BBB;
